const styles = theme => ({

  dialogContent: {
    textAlign: 'center',
  },
  btnClose: {
    height: '40px',
    textAlign: 'right',
  },
  logo: {
    marginTop: '2px',
  },

  activeDialog: {
    borderRadius: 0,
    height: '317px',
    width: '600px',
  },

  content: {
    padding: '35px 40px',
    position: 'relative',
  },

  btActive: {
    alignItems: 'center',
    background: theme.color.indigo,
    color: theme.color.white,
    display: 'flex',
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontStyle: 'Medium',
    height: '40px',
    justifyContent: 'center',
    letterSpacing: '0.01px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '24px',
    maxWidth: '320px',
    textDecoration: 'none',
    textTransform: 'uppercase',
    width: '224px',
    '&:hover': {
      backgroundColor: theme.color.chambray,
      border: `1px solid ${theme.color.chambray}`,
      color: theme.color.white,
    },
  },

  titleDialog: {
    fontFamily: 'Roboto',
    fontSize: '24px',
    fontStyle: 'Medium',
    fontWeight: 'bold',
    letterSpacing: '0.01px',
    marginBottom: '8px',
    opacity: 1,

  },
  descriptionDialog: {
    color: theme.color.dark,
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontStyle: 'Regular',
  },

  title: {
    color: theme.color.tundora,
    fontSize: '24px',
    fontWeight: 'normal',
    margin: '0 0 5px',
  },
  message: {
    color: theme.color.tundora,
    fontSize: '14px',
    lineHeight: '20px',
    margin: '0 0 15px',
  },
  warning: {
    borderRadius: '2px',
    marginBottom: '30px',
    padding: '15px',
  },
  actions: {
    textAlign: 'center',
  },
  btnCancel: {
    borderColor: theme.color.geyser,
    color: theme.color.indigo,
    marginRight: '10px',
  },
});

export default styles;
